var _style, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _circle2, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,420.59H76.47c-14.62,0-26.47-11.85-26.47-26.47c0-14.62,11.85-26.47,26.47-26.47h105.88 c14.62,0,26.47,11.85,26.47,26.47C208.82,408.74,196.97,420.59,182.35,420.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.47,208.82c-14.62,0-26.47-11.85-26.47-26.47V76.47C50,61.85,61.85,50,76.47,50s26.47,11.85,26.47,26.47v105.88 C102.94,196.97,91.09,208.82,76.47,208.82z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.47,
    cy: 288.24,
    r: 26.47
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M394.12,526.47H76.47C61.85,526.47,50,514.62,50,500c0-14.62,11.85-26.47,26.47-26.47h317.65 c14.62,0,26.47,11.85,26.47,26.47C420.59,514.62,408.74,526.47,394.12,526.47z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.47,844.12c-14.62,0-26.47-11.85-26.47-26.47V711.77c0-14.62,11.85-26.47,26.47-26.47s26.47,11.85,26.47,26.47v105.88 C102.94,832.27,91.09,844.12,76.47,844.12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M500,102.94H182.35c-14.62,0-26.47-11.85-26.47-26.47S167.73,50,182.35,50H500c14.62,0,26.47,11.85,26.47,26.47 S514.62,102.94,500,102.94z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,844.12c-14.62,0-26.47-11.85-26.47-26.47V711.77c0-14.62,11.85-26.47,26.47-26.47c14.62,0,26.47,11.85,26.47,26.47 v105.88C208.82,832.27,196.97,844.12,182.35,844.12z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.24,
    cy: 288.24,
    r: 26.47
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.24,
    cy: 923.53,
    r: 26.47
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M500,526.47c-14.62,0-26.47-11.85-26.47-26.47V182.35c0-14.62,11.85-26.47,26.47-26.47s26.47,11.85,26.47,26.47V500 C526.47,514.62,514.62,526.47,500,526.47z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,950H500c-14.62,0-26.47-11.85-26.47-26.47s11.85-26.47,26.47-26.47h317.65c14.62,0,26.47,11.85,26.47,26.47 S832.27,950,817.65,950z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M605.88,314.71c-14.62,0-26.47-11.85-26.47-26.47V76.47c0-14.62,11.85-26.47,26.47-26.47c14.62,0,26.47,11.85,26.47,26.47 v211.77C632.35,302.86,620.5,314.71,605.88,314.71z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,844.12H605.88c-14.62,0-26.47-11.85-26.47-26.47c0-14.62,11.85-26.47,26.47-26.47h211.77 c14.62,0,26.47,11.85,26.47,26.47C844.12,832.26,832.27,844.12,817.65,844.12z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M711.76,208.82c-14.62,0-26.47-11.85-26.47-26.47V76.47c0-14.62,11.85-26.47,26.47-26.47c14.62,0,26.47,11.85,26.47,26.47 v105.88C738.23,196.97,726.38,208.82,711.76,208.82z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M711.76,738.23c-14.62,0-26.47-11.85-26.47-26.47V500c0-14.62,11.85-26.47,26.47-26.47c14.62,0,26.47,11.85,26.47,26.47 v211.77C738.23,726.39,726.38,738.23,711.76,738.23z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,526.47c-14.62,0-26.47-11.85-26.47-26.47V288.24c0-14.62,11.85-26.47,26.47-26.47c14.62,0,26.47,11.85,26.47,26.47 V500C844.12,514.62,832.27,526.47,817.65,526.47z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.65,
    cy: 711.76,
    r: 26.47
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 923.53,
    cy: 76.47,
    r: 26.47
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 923.53,
    cy: 605.88,
    r: 26.47
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 923.53,
    cy: 923.53,
    r: 26.47
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP6);
export default __webpack_public_path__ + "static/media/P6.28f6a2fc5911eb41011864ad49833b71.svg";
export { ForwardRef as ReactComponent };